<script setup lang="ts">
/** Appendix C — Senior Management in place of BO (Corporate signatory). */
import { inject, computed } from 'vue';
import BoAppendixDocVarField from './BoAppendixDocVarField.vue';
import SmParticularsTable from './parts/SmParticularsTable.vue';
import BoAppendixSigners from './parts/BoAppendixSigners.vue';
import { BO_APPENDIX_DOC_CTX } from './boAppendixContext';
import { normalizeSmReasonId, type BoSmReasonId } from './mapBoJsonToAppendix';

const ctx = inject(BO_APPENDIX_DOC_CTX)!;
const reasonId = computed(() => normalizeSmReasonId(ctx.valueOf('ba04_sm_reason_id')));

function mark(on: boolean) { return on ? '☒' : '☐'; }
function isOn(id: 1 | 2 | 3) { return reasonId.value === id; }

/** Q13 SMReasonId 1/2/3 — 라디오식 (다시 클릭 시 해제) */
function toggleReason(id: 1 | 2 | 3) {
  const next: BoSmReasonId = reasonId.value === id ? 0 : id;
  ctx.setFieldValue('ba04_sm_reason_id', next ? String(next) : '');
}
</script>

<template>
  <div class="allot-doc">
    <p class="doc-sec-title">Appendix C</p>
    <p class="doc-p" style="text-align:center; margin-top:-4px">
      (The company has no beneficial owner, beneficial owner cannot be identified &amp;<br />
      in the process of obtaining beneficial ownership information)
    </p>

    <SmParticularsTable key-prefix="ba04_" />

    <p class="doc-p" style="padding-top:10px">
      <b>13.</b> Reason for naming the senior management in place of the beneficial owner<br />
      Please tick ( ) whichever applicable
    </p>
    <p class="doc-p" style="padding-left:8px">
      <span class="doc-toggle" @click.stop="toggleReason(1)">{{ mark(isOn(1)) }} The company has no beneficial owner</span><br />
      <span class="doc-toggle" @click.stop="toggleReason(2)">{{ mark(isOn(2)) }} Beneficial owner cannot be identified</span><br />
      <span class="doc-toggle" @click.stop="toggleReason(3)">{{ mark(isOn(3)) }} In the process of obtaining ownership information</span>
    </p>

    <p class="doc-p" style="padding-top:14px">We hereby declare as follows:</p>
    <p class="doc-p" style="font-style:italic; padding-left:8px">
      “We hereby confirmed that the facts and information stated in this letter are true and to the best of our knowledge and belief.”
    </p>
    <BoAppendixSigners var-key="BA04" />
    <p class="doc-p" style="padding-top:4px">
      Director &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Director<br />
      For and on behalf of<br />
      <BoAppendixDocVarField field-key="ba04_member_name" />
      (Company Registration No. <BoAppendixDocVarField field-key="ba04_member_registration_no" />)
    </p>
  </div>
</template>

<style src="./boAppendixDoc.css"></style>
